
import './App.css';
const name = "nikita"
const favWebsite = {favWebsiteName:"reddit", url:"https://www.reddit.com/"}
const colorArr = ["Червоний", "Синій", "Зелений"]
const firstNum  = 1
const secondNum = 4


function App() {
  return (
    <>
    <h1>{name}</h1>
    <p>Ласкаво просимо до нашого сайту!</p>
    <img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdigitad.ca%2Fwp-content%2Fuploads%2F2023%2F01%2Fphoto-unsplash.jpg&f=1&nofb=1&ipt=ba1bd515b5e89b37a5ae0ba3314e4bf1b61dd0bf85260eef11f577d153f490be' alt='forest' width={500}/>
    <a href={favWebsite.url} target='_blank' rel='noreferrer'>reddit</a>
    <p>result of sum {firstNum+secondNum}</p>

    <ul>{
				colorArr.map((mapped)=>{
					return (
						<li key={mapped}>
							<p>{mapped}</p>
						</li>
            
					)
				})
				
				}</ul>
    </>
  )
}

export default App;
